import { module } from 'angular';

import { AgentBookingMailAccepting, default as agentBookingMailAccepting } from './accepting/agent-booking-mail-accepting.component.ajs';
import { AgentBookingMailAllocated, default as agentBookingMailAllocated } from './allocated/agent-booking-mail-allocated.component.ajs';
import {
  AgentBookingMailInprocessAcceptReview,
  default as agentBookingMailInprocessAcceptReview,
} from './inprocess-accept-review/agent-booking-mail-inprocess-accept-review.component.ajs';
import {
  AgentBookingMailInprocessAnswerAskForHelp,
  default as agentBookingMailInprocessAnswerAskForHelp,
} from './inprocess-answer-ask-for-help/agent-booking-mail-inprocess-answer-ask-for-help.component.ajs';
import {
  AgentBookingMailInprocessAskForHelp,
  default as agentBookingMailInprocessAskForHelp,
} from './inprocess-ask-for-help/agent-booking-mail-inprocess-ask-for-help.component.ajs';
import {
  AgentBookingMailInprocessAssist,
  default as agentBookingMailInprocessAssist,
} from './inprocess-assist/agent-booking-mail-inprocess-assist.component.ajs';
import {
  AgentBookingMailInprocessClose,
  default as agentBookingMailInprocessClose,
} from './inprocess-close/agent-booking-mail-inprocess-close.component.ajs';
import {
  AgentBookingMailInprocessDelegate,
  default as agentBookingMailInprocessDelegate,
} from './inprocess-delegate/agent-booking-mail-inprocess-delegate.component.ajs';
import {
  AgentBookingMailInprocessForward,
  default as agentBookingMailInprocessForward,
} from './inprocess-forward/agent-booking-mail-inprocess-forward.component.ajs';
import {
  AgentBookingMailInprocessKnowledgeUnit,
  default as agentBookingMailInprocessKnowledgeUnit,
} from './inprocess-knowledge-unit/agent-booking-mail-inprocess-knowledge-unit.component.ajs';
import {
  AgentBookingMailInprocessKnowledge,
  default as agentBookingMailInprocessKnowledge,
} from './inprocess-knowledge/agent-booking-mail-inprocess-knowledge.component.ajs';
import {
  AgentBookingMailInprocessRejectReview,
  default as agentBookingMailInprocessRejectReview,
} from './inprocess-reject-review/agent-booking-mail-inprocess-reject-review.component.ajs';
import {
  AgentBookingMailInprocessReview,
  default as agentBookingMailInprocessReview,
} from './inprocess-review/agent-booking-mail-inprocess-review.component.ajs';
import {
  AgentBookingMailInprocessUnit,
  default as agentBookingMailInprocessUnit,
} from './inprocess-unit/agent-booking-mail-inprocess-unit.component.ajs';
import { AgentBookingMailInprocess, default as agentBookingMailInprocess } from './inprocess/agent-booking-mail-inprocess.component.ajs';
import { ContactViewMailLayout, default as contactViewMailLayout } from './layout/contact-view-mail-layout.component.ajs';
import {
  AgentBookingMailQualification,
  default as agentBookingMailQualification,
} from './qualification/agent-booking-mail-qualification.component.ajs';

export default module('contact.agent.contact-view.mail.state', [])
  .component(contactViewMailLayout, new ContactViewMailLayout())
  .component(agentBookingMailAccepting, new AgentBookingMailAccepting())
  .component(agentBookingMailAllocated, new AgentBookingMailAllocated())
  .component(agentBookingMailInprocess, new AgentBookingMailInprocess())
  .component(agentBookingMailInprocessAcceptReview, new AgentBookingMailInprocessAcceptReview())
  .component(agentBookingMailInprocessAnswerAskForHelp, new AgentBookingMailInprocessAnswerAskForHelp())
  .component(agentBookingMailInprocessAskForHelp, new AgentBookingMailInprocessAskForHelp())
  .component(agentBookingMailInprocessAssist, new AgentBookingMailInprocessAssist())
  .component(agentBookingMailInprocessClose, new AgentBookingMailInprocessClose())
  .component(agentBookingMailInprocessDelegate, new AgentBookingMailInprocessDelegate())
  .component(agentBookingMailInprocessForward, new AgentBookingMailInprocessForward())
  .component(agentBookingMailInprocessKnowledge, new AgentBookingMailInprocessKnowledge())
  .component(agentBookingMailInprocessKnowledgeUnit, new AgentBookingMailInprocessKnowledgeUnit())
  .component(agentBookingMailInprocessRejectReview, new AgentBookingMailInprocessRejectReview())
  .component(agentBookingMailInprocessReview, new AgentBookingMailInprocessReview())
  .component(agentBookingMailInprocessUnit, new AgentBookingMailInprocessUnit())
  .component(agentBookingMailQualification, new AgentBookingMailQualification()).name;
